import React from 'react';
import PropTypes from 'prop-types';

import { Field, connect } from 'formik';

import SelectCountry from '../../../CommonV2/SelectCountry';

/**
 *
 * @returns {XML}
 * @constructor
 * @param props
 */
const FieldSelectCountry = ({ code, disabled, selection, validate, handleChange, existError, showError, isMulti }) => (
  <Field
    component={SelectCountry}
    name={code}
    disabled={disabled}
    validate={validate}
    eventEmitter={v => handleChange(v)}
    selection={selection}
    existError={existError}
    showError={showError}
    isMulti={isMulti}
  />
);

FieldSelectCountry.propTypes = {
  code: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  // eslint-disable-next-line react/forbid-prop-types
  selection: PropTypes.array.isRequired,
  validate: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  existError: PropTypes.bool.isRequired,
  showError: PropTypes.bool.isRequired,
  isMulti: PropTypes.bool,
};
FieldSelectCountry.defaultProps = {
  isMulti: false,
  disabled: false,
};
export default connect(FieldSelectCountry);
